export const DEFAULT_FILTERS = { preset: "30d", from: "", to: "", market: "" };
export const FILTER_MARKETS = [["", "Todos os países"], ["BR", "🇧🇷 Brasil"], ["US", "🇺🇸 Estados Unidos"], ["PT", "🇵🇹 Portugal"], ["ES", "🇪🇸 Espanha"], ["FR", "🇫🇷 França"], ["IT", "🇮🇹 Itália"]];

export const filterParams = (f) => ({
  ...(f.from ? { date_from: f.from, date_to: f.to || undefined } : { preset: f.preset }),
  ...(f.market ? { market: f.market } : {}),
});

export const filterQuery = (f) => {
  const p = new URLSearchParams();
  Object.entries(filterParams(f)).forEach(([k, v]) => { if (v) p.set(k, v); });
  return p.toString();
};
